import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockClosed24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLockClosed24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15 7v1H9V7a3 3 0 1 1 6 0M7.5 8V7a4.5 4.5 0 0 1 9 0v1h.5a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3zm9 1.5H7A1.5 1.5 0 0 0 5.5 11v7A1.5 1.5 0 0 0 7 19.5h10a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 17 9.5zm-3.772 5.851a1.5 1.5 0 1 0-1.424.018.8.8 0 0 0-.035.228v.807a.75.75 0 0 0 1.5 0v-.807a.8.8 0 0 0-.041-.246"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockClosed24);
